// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"spinner_spinnerWrapper__2Pjfd","spinner":"spinner_spinner__IDGCg","rotation":"spinner_rotation__1qNZi"};